import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AuthPageWrapper, AuthPageTitle } from 'features/auth';

import { SignInForm } from '../SignInForm';
import { TextW } from './styled';

type LocationState = {
  companyRegistration?: boolean;
  userSignUp?: boolean;
};

const titleSx = {
  fontSize: '40px',
  lineHeight: '44px',

  '@media (max-width: 1023px)': {
    fontSize: '40px',
    lineHeight: '44px',
  },
};

export function SignInPage(): ReactElement {
  const { state = {} } = useLocation();
  const userSignUp = (state as LocationState)?.userSignUp;
  const { t } = useTranslation();

  const firstTimeSignIn = Boolean(state);
  const showSubtitle = !firstTimeSignIn || userSignUp;

  const pageTitle = t(firstTimeSignIn ? 'login.title.firstTime' : 'login.title.regular');
  const subtitle = t(firstTimeSignIn ? 'login.subtitle.userSignUp' : 'login.subtitle.regular');

  return (
    <AuthPageWrapper>
      <AuthPageTitle sx={titleSx}>{pageTitle}</AuthPageTitle>

      {showSubtitle && <TextW>{subtitle}</TextW>}

      <SignInForm firstTimeSignIn={Boolean(firstTimeSignIn)} />
    </AuthPageWrapper>
  );
}
